// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mast {
  height: 50px;
  background-color: #3874cb;
  display: block;
  position: relative;
}

img.logo {
  padding-top: 5px;
}

span.title {
  color: white;
  font-size: large;
  font-weight: bold;
  padding: 10px;
  position: absolute;
  top: 5px;
}

span.username {
  color: white;
  font-weight: bold;
  padding-top: 18px;
  float: right;
  width: 200px;
  text-align: center;
}
.nav-ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  /* border: 1px solid #e7e7e7; */
  background-color: #ddd;
}

.nav-li {
  float: left;
}

.nav-li a {
  display: block;
  color: #999;
  font-weight: bold;
  text-align: center;
  padding: 16px;
  text-decoration: none;
  width: auto;
  max-width: 100px;
}

.nav-li a.inactive:hover {
  background-color: #eee;
}

.nav-li a.is-active {
  color: #3874cb;
  /* background-color: #008CBA; */
  /* background-color: #3874cb; */
  background-color: white;
}

.search-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  padding: 10px;
}

.search-container {
  align-self: center;
}

#select-criteria {
  height: 33.5px;
  background-color: #EAEAEAEA;
}

.csv-export {
  align-self: self-end;
}
.csv-export-btn {
  width: 120px;
  height: 33.5px;
}

.hide {
  display: none;
}

.no-decoration {
  color: inherit;
  text-decoration: none;
}

/*MUI-X Hack*/

div.MuiDialog-container .MuiTextField-root {
  padding: 10px !important;
  min-width: 250px;
}

div.MuiDialog-container .MuiInputLabel-root {
  color: #3874cb !important;
}

div.MuiDialog-container .MuiInputBase-root {
  border-radius: 0;
}

div.MuiDataGrid-root {
  border-top: none;
}

.MuiDataGrid-main > div:last-child {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,aAAa;;AAEb;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".mast {\n  height: 50px;\n  background-color: #3874cb;\n  display: block;\n  position: relative;\n}\n\nimg.logo {\n  padding-top: 5px;\n}\n\nspan.title {\n  color: white;\n  font-size: large;\n  font-weight: bold;\n  padding: 10px;\n  position: absolute;\n  top: 5px;\n}\n\nspan.username {\n  color: white;\n  font-weight: bold;\n  padding-top: 18px;\n  float: right;\n  width: 200px;\n  text-align: center;\n}\n.nav-ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  /* border: 1px solid #e7e7e7; */\n  background-color: #ddd;\n}\n\n.nav-li {\n  float: left;\n}\n\n.nav-li a {\n  display: block;\n  color: #999;\n  font-weight: bold;\n  text-align: center;\n  padding: 16px;\n  text-decoration: none;\n  width: auto;\n  max-width: 100px;\n}\n\n.nav-li a.inactive:hover {\n  background-color: #eee;\n}\n\n.nav-li a.is-active {\n  color: #3874cb;\n  /* background-color: #008CBA; */\n  /* background-color: #3874cb; */\n  background-color: white;\n}\n\n.search-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: center;\n  padding: 10px;\n}\n\n.search-container {\n  align-self: center;\n}\n\n#select-criteria {\n  height: 33.5px;\n  background-color: #EAEAEAEA;\n}\n\n.csv-export {\n  align-self: self-end;\n}\n.csv-export-btn {\n  width: 120px;\n  height: 33.5px;\n}\n\n.hide {\n  display: none;\n}\n\n.no-decoration {\n  color: inherit;\n  text-decoration: none;\n}\n\n/*MUI-X Hack*/\n\ndiv.MuiDialog-container .MuiTextField-root {\n  padding: 10px !important;\n  min-width: 250px;\n}\n\ndiv.MuiDialog-container .MuiInputLabel-root {\n  color: #3874cb !important;\n}\n\ndiv.MuiDialog-container .MuiInputBase-root {\n  border-radius: 0;\n}\n\ndiv.MuiDataGrid-root {\n  border-top: none;\n}\n\n.MuiDataGrid-main > div:last-child {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
